/* eslint-disable react/require-default-props */
import React from 'react';
import externalLinkIcon from 'assets/icons/common/external-link.svg';
import Tooltip from '../tooltip';

type ExternalLinkProps = {
  href: string;
  styles?: string;
};

export default function ExternalLink({ href, styles }: ExternalLinkProps) {
  return (
    <Tooltip message="Open">
      <a href={href} rel="noreferrer" target="_blank" className={`mt-1 h-4 w-4 sm:w-6 sm:h-6 ${styles}`}>
        <img src={externalLinkIcon} alt="External Link" />
      </a>
    </Tooltip>
  );
}
